<template>
  <v-tab @click="startStopTimer">
    <v-icon class="mx-1">mdi-alarm</v-icon> {{ formattedTime }}
  </v-tab>
</template>

<script>
export default {
  data: () => ({
    timer_interval: null,
    time_passed: 0,
  }),
  computed: {
    formattedTime() {
      const time_passed = this.time_passed
      const minutes = Math.floor(time_passed / 60)
      let seconds = time_passed % 60
      if (seconds < 10) seconds = `0${seconds}`
      return `${minutes}:${seconds}`
    },

  },
  watch: {

  },
  mounted() {

  },
  beforeDestroy() {
    this.stopTimer()
  },
  methods: {
    startStopTimer() {
      console.log(this.timer_interval)
      if(this.timer_interval) this.stopTimer()
      else this.startTimer()
    },
    startTimer() {
      this.timer_interval = setInterval(() => (this.time_passed += 1), 1000);
    },
    stopTimer () {
      clearInterval(this.timer_interval);
      this.timer_interval = null
      this.time_passed = 0
    }
  }
}
</script>